import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { showCurrencySymbol } from "../../helper/generalHelper";

const EditAllItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editOrder = location.state?.order || null;

  // State
  const [menus, setMenus] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [orderNote, setOrderNote] = useState("");
  const [extraTaxValue, setExtraTaxValue] = useState(0);
  const [discountType, setDiscountType] = useState("fixed");
  const [discountValue, setDiscountValue] = useState(0);
  const [otherCostValue, setOtherCostValue] = useState(0);
  const [otherCostLabel, setOtherCostLabel] = useState("");
  const [orderTypeLocal, setOrderTypeLocal] = useState("takeaway");
  const [tableNumber, setTableNumber] = useState(null);
  const [tableName, setTableName] = useState(null);

  // Toggles
  const [showNote, setShowNote] = useState(false);
  const [showDiscount, setShowDiscount] = useState(false);
  const [showOtherCost, setShowOtherCost] = useState(false);
  const [showTax, setShowTax] = useState(false);

  // Prefill edit order
  useEffect(() => {
    if (editOrder) {
      setOrderNote(editOrder.note || "");
      setExtraTaxValue(editOrder.extra_tax_amout || 0);
      setDiscountType(editOrder.extra_discount_type || "fixed");
      setDiscountValue(editOrder.extra_discount_amount || 0);
      setOtherCostValue(editOrder.other_cost || 0);
      setOtherCostLabel(editOrder.other_cost_type || "");
      setSelectedCustomerId(editOrder.customer_id || "");
      setOrderTypeLocal(editOrder.order_type || "takeaway");
      setTableNumber(editOrder.table_number || null);
      setTableName(editOrder.table_name || null);

      // Map order_details to menus
      const mappedMenus = (editOrder.order_details || []).map((item) => ({
        menuId: item.menu_id,
        quantity: item.quantity,
        price: Number(item.price),
        title: `Menu ${item.menu_id}`, // Replace with actual title if available
      }));

      setMenus(mappedMenus);
    }
  }, [editOrder]);

  const handleProductClick = (menuId) => {
    setMenus((prev) =>
      prev.map((m) =>
        m.menuId === menuId ? { ...m, quantity: m.quantity + 1 } : m
      )
    );
  };

  const handleRemoveItem = (menuId) => {
    setMenus((prev) =>
      prev.map((m) =>
        m.menuId === menuId
          ? { ...m, quantity: Math.max(m.quantity - 1, 0) }
          : m
      )
    );
  };

  const getItemCount = (menuId) =>
    menus.find((m) => m.menuId === menuId)?.quantity || 0;

  const cartItems = menus.filter((m) => m.quantity > 0);
  const subtotal = cartItems.reduce(
    (acc, item) => acc + (item.price || 0) * item.quantity,
    0
  );
  const discountAmount =
    discountType === "percentage"
      ? (subtotal * Number(discountValue)) / 100
      : Number(discountValue);
  const total =
    subtotal + Number(extraTaxValue) + Number(otherCostValue) - discountAmount;

  const handleUpdateOrder = () => {
  if (!cartItems.length) return alert("Cart is empty.");

  const payload = {
    id: editOrder.id,
    orderDate: editOrder.order_date,
    orderTime: editOrder.order_time,
    orderType: orderTypeLocal,
    orderStatus: 10,
    paymentStatus: 17,
    customerId: selectedCustomerId || "",
    tableNumber: orderTypeLocal === "table" ? tableNumber : null,
    extraTax: Number(extraTaxValue) || 0,
    extraDiscountType: discountType,
    extraDiscount: Number(discountValue) || 0,
    otherCost: Number(otherCostValue) || 0,
    otherCostType: otherCostLabel || "",
    note: orderNote || "",
    menus: cartItems.map((item) => ({
      menuId: item.menuId,
      quantity: item.quantity,
    })),
  };

  // API call
  api
    .post(`restaurant/order/update`, payload)
    .then((res) => {
      alert("Order updated successfully!");
      navigate("/restaurant/orders"); // Redirect to orders list
    })
    .catch((err) => {
      console.error("Update Order Error:", err);
      alert("Failed to update order. Check console for details.");
    });
};

  return (
    <div className="flex flex-col h-screen bg-gray-50 relative">
      {/* Search */}
      <div className="p-4 bg-white border-b sticky top-0 z-20">
        <input
          type="text"
          placeholder="🔍 Search for a dish..."
          className="w-full p-3 rounded-xl border text-sm focus:ring-2 focus:ring-rose-400 outline-none"
        />
      </div>

      {/* Editable Order Info */}
      <div className="px-4 py-2 text-sm bg-white shadow-sm space-y-2">
        {/* <div>
          <label className="font-semibold">Customer ID:</label>
          <input
            type="text"
            value={selectedCustomerId}
            onChange={(e) => setSelectedCustomerId(e.target.value)}
            className="w-full border p-1 rounded mt-1"
          />
        </div> */}

        <div>
          <label className="font-semibold">Order Type:</label>
          <select
            value={orderTypeLocal}
            onChange={(e) => setOrderTypeLocal(e.target.value)}
            className="w-full border p-1 rounded mt-1"
          >
            <option value="takeaway">Takeaway</option>
            <option value="table">Dine-in / Table</option>
          </select>
        </div>

        {orderTypeLocal === "table" && (
          <div>
            <label className="font-semibold">Table:</label>
            <div className="w-full border p-1 rounded mt-1 bg-gray-50 text-gray-700">
              {tableName || `ID: ${tableNumber}`}
            </div>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="flex flex-1 overflow-hidden">
        {/* Product Grid */}
        <div className="flex-1 p-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 overflow-y-auto">
          {menus?.map((product) => (
            <div
              key={product.menuId}
              onClick={() => handleProductClick(product.menuId)}
              className="relative rounded-xl bg-white shadow hover:shadow-lg cursor-pointer transition h-24 flex flex-col"
            >
              <div className="flex-1 p-3 flex flex-col justify-between">
               
                <p
                  className="text-sm font-semibold text-gray-800 truncate"
                  title={product.title}
                >
                  {product.title || `Menu ${product.menuId}`}
                </p>
                <p className="text-rose-600 font-bold text-sm mt-1">
                  {showCurrencySymbol(product.price || 0)}
                </p>
              </div>
              {getItemCount(product.menuId) > 0 && (
                <span className="absolute top-2 right-2 bg-green-600 text-white text-xs px-2 py-1 rounded-full shadow">
                  x{getItemCount(product.menuId)}
                </span>
              )}
            </div>
          ))}
        </div>

        {/* Cart Sidebar */}
        <div className="hidden md:flex flex-col md:w-[30%] border-l bg-white p-4 overflow-y-auto shadow-sm">
          <h2 className="text-lg font-bold mb-3">🛒 Cart Summary</h2>
          {cartItems.length === 0 ? (
            <p className="text-gray-500 text-sm">No items yet</p>
          ) : (
            <>
              <ul className="space-y-3 text-sm">
                {cartItems.map((item) => (
                  <li
                    key={item.menuId}
                    className="flex justify-between items-center bg-gray-100 p-2 rounded"
                  >
                    <div className="flex items-center gap-3 w-2/3">
                      <div className="flex flex-col">
                        <p className="font-medium truncate">
                          {item.title || `Menu ${item.menuId}`}
                        </p>
                        <div className="flex items-center gap-2 mt-1">
                          <button
                            onClick={() => handleRemoveItem(item.menuId)}
                            className="px-2 py-0.5 bg-gray-200 rounded hover:bg-gray-300"
                          >
                            -
                          </button>
                          <span className="text-sm">{item.quantity}</span>
                          <button
                            onClick={() => handleProductClick(item.menuId)}
                            className="px-2 py-0.5 bg-gray-200 rounded hover:bg-gray-300"
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => handleRemoveItem(item.menuId)}
                      className="text-red-500 hover:text-red-700 text-lg"
                    >
                      ✕
                    </button>
                  </li>
                ))}
              </ul>

              {/* Extra Inputs */}
              <div className="mt-4 space-y-2 text-sm">
                {/* Order Note */}
                <div>
                  <button
                    className="w-full flex justify-between items-center bg-gray-100 px-3 py-2 rounded"
                    onClick={() => setShowNote(!showNote)}
                  >
                    <span>📝 Add Note</span>
                    <span>{showNote ? "➖" : "➕"}</span>
                  </button>
                  {showNote && (
                    <textarea
                      placeholder="Order Note"
                      value={orderNote}
                      onChange={(e) => setOrderNote(e.target.value)}
                      className="w-full border p-2 mt-2 rounded"
                    />
                  )}
                </div>

                {/* Extra Tax */}
                <div>
                  <button
                    className="w-full flex justify-between items-center bg-gray-100 px-3 py-2 rounded"
                    onClick={() => setShowTax(!showTax)}
                  >
                    <span>💰 Extra Tax</span>
                    <span>{showTax ? "➖" : "➕"}</span>
                  </button>
                  {showTax && (
                    <input
                      type="number"
                      placeholder="Extra Tax"
                      value={extraTaxValue}
                      onChange={(e) => setExtraTaxValue(e.target.value)}
                      className="w-full border p-2 mt-2 rounded"
                    />
                  )}
                </div>

                {/* Discount */}
                <div>
                  <button
                    className="w-full flex justify-between items-center bg-gray-100 px-3 py-2 rounded"
                    onClick={() => setShowDiscount(!showDiscount)}
                  >
                    <span>🏷️ Discount</span>
                    <span>{showDiscount ? "➖" : "➕"}</span>
                  </button>
                  {showDiscount && (
                    <div className="space-y-2 mt-2">
                      <select
                        value={discountType}
                        onChange={(e) => setDiscountType(e.target.value)}
                        className="w-full border p-2 rounded"
                      >
                        <option value="fixed">Fixed</option>
                        <option value="percentage">Percentage</option>
                      </select>
                      <input
                        type="number"
                        placeholder="Discount Value"
                        value={discountValue}
                        onChange={(e) => setDiscountValue(e.target.value)}
                        className="w-full border p-2 rounded"
                      />
                    </div>
                  )}
                </div>

                {/* Other Cost */}
                <div>
                  <button
                    className="w-full flex justify-between items-center bg-gray-100 px-3 py-2 rounded"
                    onClick={() => setShowOtherCost(!showOtherCost)}
                  >
                    <span>➕ Other Cost</span>
                    <span>{showOtherCost ? "➖" : "➕"}</span>
                  </button>
                  {showOtherCost && (
                    <div className="space-y-2 mt-2">
                      <input
                        type="number"
                        placeholder="Other Cost Value"
                        value={otherCostValue}
                        onChange={(e) => setOtherCostValue(e.target.value)}
                        className="w-full border p-2 rounded"
                      />
                      <input
                        type="text"
                        placeholder="Other Cost Label"
                        value={otherCostLabel}
                        onChange={(e) => setOtherCostLabel(e.target.value)}
                        className="w-full border p-2 rounded"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Totals */}
              <div className="mt-auto pt-4 border-t space-y-2 text-sm">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span>{showCurrencySymbol(subtotal)}</span>
                </div>
                <div className="flex justify-between">
                  <span>Discount</span>
                  <span>- {showCurrencySymbol(discountAmount)}</span>
                </div>
                <div className="flex justify-between font-bold border-t pt-2">
                  <span>Total</span>
                  <span>{showCurrencySymbol(total)}</span>
                </div>
                <button
                  onClick={handleUpdateOrder}
                  className="mt-4 bg-rose-600 hover:bg-rose-700 text-white py-2 rounded-lg text-sm font-semibold shadow-md w-full"
                >
                  ✅ Update Order
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditAllItems;
